import { useEffect, useState } from "react";

type FormValues = Record<string, any>;

type UseFormValuesInput =
	| FormValues
	| {
			initialValues: FormValues;
	  };

export default function useFormValues(input: UseFormValuesInput) {
	const initialValues =
		"initialValues" in input ? input.initialValues : input;

	const [values, setValues] = useState<FormValues>(initialValues || {});

	useEffect(() => {
		setValues(initialValues || {});
	}, [initialValues]);

	const handleOnChange = (key: string, value: any) => {
		setValues((previousValues) => ({
			...previousValues,
			[key]: value,
		}));
	};

	const refresh = () => {
		setValues(initialValues || {});
	};

	return { values, setValues, handleOnChange, refresh };
}
